module.exports = __webpack_public_path__ + "static/wishlist2-ff1bceda21afe7d15f37506dcfcf705d.png";